import { mediaUrl } from "../../lib/media";
import { BannerLink } from "./BannerLink";

/** Banner tengah: satu gambar utuh, tanpa teks di atasnya. Sembunyi bila tanpa gambar. */
export function PromoBanner({ banner }) {
  if (!banner || (!banner.gambar && !banner.gambar_hp)) return null;
  const desktop = banner.gambar || banner.gambar_hp;
  const mobile = banner.gambar_hp || banner.gambar;
  return (
    <section className="px-4 py-6 md:px-20" data-testid="middle-banner">
      <div className="mx-auto w-full max-w-[1280px]">
        <BannerLink href={banner.href} className="block relative overflow-hidden aspect-[179/110] md:aspect-[56/13]" tid="middle-banner-link">
          <picture className="block w-full h-full">
            <source media="(max-width: 767px)" srcSet={mediaUrl(banner.gambar_hp || banner.gambar_960 || mobile)} />
            <img src={mediaUrl(desktop)} alt={banner.alt || ""}
                 width="1280" height="297" loading="lazy" decoding="async"
                 className="block w-full h-full object-cover object-center" />
          </picture>
        </BannerLink>
      </div>
    </section>
  );
}
